{
  "header": "資產詳細資料",
  "subtitle": "連接在您貨車上的資產（拖車、貨櫃等）。",
  "assetType": "資產類型",
  "assetTypePlaceholder": "選擇資產類型",
  "assetId": "資產編號（例如拖車編號）",
  "assetIdPlaceholder": "例如：拖車編號、貨櫃編號等",
  "remove": "移除",
  "addAnother": "新增其他資產",
  "trailerType": "拖車類型",
  "trailerId": "拖車編號"
}
